<template>
  <div class="chat-audio" @click="handleClick">
    <span>{{ second }}"</span>
    <voice-icon
      class="icon"
      :color="isSend ? '#ffffff' : '#193a79'"
      :direction="isSend ? 'left' : 'right'"
      :active="playStatus"
    />
  </div>
</template>

<script>
import voiceIcon from './voiceIcon'
import * as Utils from '@/assets/script/utils'
import { mapState } from 'vuex'

export default {
  props: {
    item: Object
  },
  data() {
    return {
      playStatus: false
    }
  },
  computed: {
    ...mapState(['chatControl']),
    second() {
      const { title } = this.item
      return (title.match(/audio\(([\s\S]+?)\)\[/) || [])[1]
    },
    isSend() {
      const { type } = this.item
      return Utils.checkType('SEND', type)
    }
  },
  methods: {
    handleClick() {
      if (this.playStatus) return
      const { title, id, unread } = this.item

      const path = (title.match(/\)\[([\s\S]*?)\]/) || [])[1]
      let audioNode = document.querySelector('#audio')

      if (!audioNode) {
        audioNode = document.createElement('audio')
        audioNode.id = 'audio'
        audioNode.src = path
        audioNode.hidden = true
        document.body.appendChild(audioNode)
      } else {
        audioNode.setAttribute('src', path)
      }

      this.playStatus = true
      audioNode.play()

      audioNode.addEventListener('ended', () => {
        this.playStatus = false
        !this.isSend && unread && this.chatControl.readReceiveAudio(id)
      })
    }
  },
  components: {
    voiceIcon
  }
}
</script>

<style lang="stylus">
.chat-audio {
  display: flex;
  align-items: center;

  .icon {
    margin-left: 5px;
  }
}
</style>




// WEBPACK FOOTER //
// src/views/components/chatAudio.vue